<template>
  <b-modal
    v-model="show"
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    scrollable
    size="lg"
  >
    <div slot="modal-title">
      <span class="header-title">{{ documentName }}</span>
    </div>
    <div class="document-viewer">
      <iframe id="pdfViewer" src="./pdfjs/web/viewer.html" title="PDF Viewer" />
    </div>

    <div slot="modal-footer">
      <action-button
        i="fas fa-times-circle"
        text="Cerrar"
        variant="outline-danger"
        @click="closeModal()"
      />
    </div>
  </b-modal>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'DocumentPreview',
  components: {
    ActionButton,
  },
  props: {
    documentSrc: {
      type: Uint8Array,
      default: () => [],
      required: true,
    },
    documentName: {
      type: String,
      default: () => '',
    },
    show: {
      type: Boolean,
      default: () => false,
      required: true,
    },
  },
  data: () => ({}),
  async created() {
    await this.openDocument(this.documentSrc);
  },
  methods: {
    async openDocument(src) {
      var source;
      if (typeof src === 'string') source = { url: src };
      else if (src instanceof Uint8Array) source = { data: src };
      else if (typeof src === 'object' && src !== null)
        source = Object.assign({}, src);
      else throw new TypeError('invalid src type');

      var iw = document.getElementById('pdfViewer').contentWindow;
      return await iw.PDFViewerApplication.open(source);
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.header-title {
  font-weight: bold;
}
</style>
